﻿import Valg from '../../../Shared/Scripts/Models/Valg';
import ValgTillegg from '../../../Shared/Scripts/Models/ValgMedtillegg';

export interface ValgState {
    aVarighet?: Valg<string>;
    bVerdensdel?: Valg<string>;
    cLand?: Valg<string>;
    dSkolepenger?: ValgTillegg<string>;
    eUniversitet?: Valg<string>; 
    visUtbetalingsplan: boolean;
}

export const UPDATE_VALG = 'UPDATE_AVALG';

interface UpdateValgAction {
    type: typeof UPDATE_VALG;
    payload: Partial<ValgState>;
}

export type ValgStateActionTypes = UpdateValgAction;
